import axios from 'axios';
import { API_BASE, getAuthToken, setAuthToken, setAdmin } from './config';

const client = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

client.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const hadAuth = error.config?.headers?.Authorization;
    if ((status === 401 || status === 403) && hadAuth) {
      setAuthToken(null);
      setAdmin(null);
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default client;
